// Custom collection pagination
document.addEventListener('DOMContentLoaded', paginateCards)
document.addEventListener('shopify:section:load', paginateCards)

function paginateCards() {
  const productGrid = document.getElementById('product-grid')
  const productList = document.querySelectorAll('#pcard')
  const pcardsize = productList.length
  const itemsPerPageElement = window.matchMedia('(max-width: 1024px)').matches
    ? 14
    : document.getElementById('pperp').innerHTML
  const itemsPerPage = parseInt(itemsPerPageElement)
  const totalPages = Math.ceil(productList.length / itemsPerPage)
  let currentPage = 1

  function showPage(page) {
    const startIndex = (page - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage

    for (let i = 0; i < productList.length; i++) {
      productList[i].style.display = i >= startIndex && i < endIndex ? 'block' : 'none'
    }

    const url = new URL(window.location.href)
    url.searchParams.set('page', page)
    window.history.replaceState(
      {
        path: url.href,
      },
      '',
      url.href,
    )

    const paginationLinks = document.getElementsByClassName('pagination-link')
    for (let i = 0; i < paginationLinks.length; i++) {
      paginationLinks[i].classList.remove('active', 'border-b-2', 'font-semibold', 'border-black')
      if (parseInt(paginationLinks[i].dataset.page) === page) {
        paginationLinks[i].classList.add('active', 'border-b-2', 'font-semibold', 'border-black')
      }
    }

    renderPagination()
  }

  function renderPagination() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    const paginationContainer = document.querySelector('.pagination')

    if (paginationContainer) {
      paginationContainer.remove()
    }

    const newPaginationContainer = document.createElement('div')
    newPaginationContainer.className = 'pagination flex gap-12 justify-center items-center'

    if (totalPages > 1) {
      if (totalPages > 4) {
        if (currentPage > 2) {
          const firstPageLink = createPaginationLink(1)
          newPaginationContainer.appendChild(firstPageLink)

          if (currentPage > 4) {
            const ellipsisLeft = document.createElement('span')
            ellipsisLeft.textContent = '...'
            newPaginationContainer.appendChild(ellipsisLeft)
          }
        }

        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          if (i >= 1 && i <= totalPages) {
            const pageLink = createPaginationLink(i)
            if (i === currentPage) {
              pageLink.classList.add('active', 'border-b-2', 'font-semibold', 'border-black')
            }
            newPaginationContainer.appendChild(pageLink)
          }
        }

        if (currentPage < totalPages - 1) {
          if (currentPage < totalPages - 2) {
            const ellipsisRight = document.createElement('span')
            ellipsisRight.textContent = '...'
            newPaginationContainer.appendChild(ellipsisRight)
          }

          const lastPageLink = createPaginationLink(totalPages)
          newPaginationContainer.appendChild(lastPageLink)
        }
      } else {
        for (let i = 1; i <= totalPages; i++) {
          const pageLink = createPaginationLink(i)
          if (i === currentPage) {
            pageLink.classList.add('active', 'border-b-2', 'font-semibold', 'border-black')
          }
          newPaginationContainer.appendChild(pageLink)
        }
      }

      if (currentPage < totalPages) {
        const nextLink = createPaginationLink(currentPage + 1, '', 'pagination-link--next')
        const chevronIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        chevronIcon.setAttribute('class', 'icon icon-chevron-right w-1.5')
        chevronIcon.setAttribute('viewBox', '0 0 6 11')
        chevronIcon.setAttribute('fill', 'none')

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        path.setAttribute(
          'd',
          'M6 5.31104L1.13514 10.1759L1.35363e-08 9.04077L3.72973 5.31104L1.0249e-07 1.58131L1.13514 0.446174L6 5.31104Z',
        )
        path.setAttribute('fill', 'currentColor')

        chevronIcon.appendChild(path)
        nextLink.appendChild(chevronIcon)
        newPaginationContainer.appendChild(nextLink)
      }
    }

    productGrid.insertAdjacentElement('afterend', newPaginationContainer)
  }

  function createPaginationLink(page, text = page.toString(), className = 'pagination-link') {
    const pageLink = document.createElement('a')
    pageLink.href = '#'
    pageLink.textContent = text
    pageLink.dataset.page = page.toString()
    pageLink.classList.add(className)
    pageLink.addEventListener('click', function (event) {
      event.preventDefault()
      currentPage = page
      showPage(currentPage)
    })
    return pageLink
  }

  const urlParams = new URLSearchParams(window.location.search)
  const pageParam = urlParams.get('page')
  if (pageParam && !isNaN(pageParam) && pageParam > 0 && pageParam <= totalPages) {
    currentPage = parseInt(pageParam)
  }

  showPage(currentPage)
  renderPagination()
}
paginateCards()

// FacetFiltersForm

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop')
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape)
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCount')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading')
    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        paginateCards()
        const html = responseText
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
    paginateCards()
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML
    paginateCards()
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount')
    const containerDesktop = document.getElementById('ProductCountDesktop')
    container.innerHTML = count
    container.classList.remove('loading')
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    )
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element))
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'))
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop']

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting']

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML
    })

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents()
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected')
    const sourceElement = source.querySelector('.facets__selected')

    const targetElementAccessibility = target.querySelector('.facets__summary')
    const sourceElementAccessibility = source.querySelector('.facets__summary')

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
    paginateCards()
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll('facet-filters-form form')
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = []
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile'

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form))
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form))
        }
      })
      this.onSubmitForm(forms.join('&'), event)
      paginateCards()
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1)
    FacetFiltersForm.renderPage(url)
    paginateCards()
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    )
    this.setMinAndMaxValues()
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input')
    const minInput = inputs[0]
    const maxInput = inputs[1]
    paginateCards()
    if (maxInput.value) minInput.setAttribute('max', maxInput.value)
    if (minInput.value) maxInput.setAttribute('min', minInput.value)
    if (minInput.value === '') maxInput.setAttribute('min', 0)
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form')
    form.onActiveFilterClick(event)
    paginateCards()
  }
}

customElements.define('facet-remove', FacetRemove)

const detailsElement = document.querySelector('details')
const solvvyContainerElements = document.querySelectorAll('div#solvvy-container')

if (detailsElement.classList.contains('menu') && detailsElement.classList.contains('opening')) {
  solvvyContainerElements.forEach((element) => {
    element.style.display = 'none' // Hide solvvy-container
  })
} else {
  solvvyContainerElements.forEach((element) => {
    element.style.display = 'block' // Show solvvy-container
  })
}
